module.exports = __webpack_public_path__ + "static/media/download.2017092b.gif";